import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Array} from 'es6-shim';
import {DictionaryObject} from '../../../../../../../../../../common/api';
import {AttachmentItem} from '../../../../../../../../shared/api/entity/attachment';


@Component({
    selector: 'tfl-corporate-profile-document',
    template: `
        <ng-container
            *ngFor="let key of getKeys(attachmentsMap)">
            <tfl-files-download
                *ngIf="attachmentsMap.get(key).length"
                [title]="key"
                [disableSaveAll]="true"
                [attachments]="attachmentsMap.get(key)"
                (downloadFile)="onDownloadFile($event)">
            </tfl-files-download>
        </ng-container>
    `
})
export class CorporateProfileDocumentComponent implements OnInit {

    @Input() attachments: AttachmentItem[];
    @Input() attachmentSubTypes: DictionaryObject[];
    @Input() profileId: number;

    @Output() downloadFile = new EventEmitter<any>();

    attachmentsMap = new Map<string, AttachmentItem[]>();

    ngOnInit(): void {
        this.groupAttachmentsBySubTypeName();
    }

    getKeys(map: Map<any, any>) {
        return Array.from(map.keys());
    }

    onDownloadFile(fileId: string) {
        this.downloadFile.emit(fileId);
    }

    private groupAttachmentsBySubTypeName() {
        this.attachments.forEach(attachment => {
            const subTypeItem = this.attachmentSubTypes
                .find(subType => attachment.attachmentSubTypeId === subType.id);
            const subTypeVal = this.attachmentsMap.get(subTypeItem.name) || [];

            subTypeVal.push(attachment);
            this.attachmentsMap.set(subTypeItem.name, subTypeVal);
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/profile-details/documents/corporate/document/corporate-profile.document.component.ts